import React from "react";
import "./VerificationModal.css";

const VerificationModal = ({ email, onClose }) => {
  return (
    <div className="verification-modal-overlay">
      <div className="verification-modal">
        <h2>이메일 인증이 필요합니다</h2>
        <p>
          <strong>{email}</strong>로 인증 메일이 발송되었습니다.
          <br />
          이메일을 확인하고 인증 링크를 클릭해주세요.
        </p>
        <button onClick={onClose}>로그인하러 가기</button>
      </div>
    </div>
  );
};

export default VerificationModal;
